<lv-label-tooltip [label]="uiArtefakt.Text" [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                  [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"></lv-label-tooltip>
<div class="lv-divider">
  <ng-container *ngFor="let artefakt of uiArtefakt.UIArtefakt, trackBy: trackByFn">
    <div class="lv-divider-artefakt">
    <lv-uiartefakt-renderer [uiArtefakt]="artefakt">
    </lv-uiartefakt-renderer>
    </div>
    <div class="lv-divider-slash">/</div>
  </ng-container>
</div>
